export const colors = {
  primary: '#FF0101',
  white: '#FFFFFF',
  black: '#000000',
  grey1: '#FBFBFB',
  grey2: '#9B9EAC',
  grey3: '#74798C',
  grey4: '#282D30',
  blue: '#4AB8FF',
  yellow: '#FDCC0C',
  pink: '#FD5181',
}
